import { MantineThemeOverride } from "@mantine/core";

const makeVsethTheme = (
	newPrimaryColor?: [
		string,
		string,
		string,
		string,
		string,
		string,
		string,
		string,
		string,
		string
	]
) => {
	console.log(newPrimaryColor);
	const vsethTheme: MantineThemeOverride = {
		colors: {
			vsethMain:
				newPrimaryColor !== undefined
					? newPrimaryColor
					: [
							"#E5F9FF",
							"#D1F3FF",
							"#9EE5FF",
							"#6BD8FF",
							"#3DC8FF",
							"#1ABEFF",
							"#00B2FF",
							"#009FE3",
							"#0A8BC7",
							"#0E78AA",
					  ],
			vsethGray: new Array(10).fill("rgb(144, 146, 150)") as any,
		},
		primaryColor: "vsethMain",
		primaryShade: 7,
		fontFamily:
			'"Source Sans Pro",Lato,Arial,Helvetica,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol',
		lineHeight: 1.5,
	};
	console.log(vsethTheme);
	return vsethTheme;
};

export default makeVsethTheme;
